module.exports = __webpack_public_path__ + "static/animaec-3fee0352bbe30c0e4d4209e20f1591a4.png";